'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (series) {
    var decimals = 0;
    var cumulativeValues = [];

    series.forEach(function (seriesObj) {
        cumulativeValues = seriesObj.data.reduce(function (accumulator, value, index) {
            decimals = Math.max(decimals, (0, _numberDecimals2.default)(value));

            if (index > 0) {
                value += accumulator[index - 1];
            }

            accumulator.push(value);

            return accumulator;
        }, []);

        // round values to the largest number of decimals found in the serie
        // this is to avoid the floating-point problems in JavaScript
        // the condition in the return statement is because sometimes value can be null
        seriesObj.data = cumulativeValues.map(function (value) {
            return value ? parseFloat(value.toFixed(decimals)) : value;
        });

        decimals = 0;
    });

    return series;
};

var _isInteger = require('d2-utilizr/lib/isInteger');

var _isInteger2 = _interopRequireDefault(_isInteger);

var _numberDecimals = require('d2-utilizr/lib/numberDecimals');

var _numberDecimals2 = _interopRequireDefault(_numberDecimals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=getCumulativeData.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/getCumulativeData.js
 ** module id = 238
 ** module chunks = 0 1
 **/